/**
 * Stripe webhook URL shown in the new-tenant form (spec §5).
 *
 * The server's WEBHOOK_BASE_URL (sent as HealthResponse.webhookBaseUrl) wins, so
 * the preview is the URL the backend will itself report for the tenant, whatever
 * origin serves the dashboard. When it is absent or blank (an older backend, or
 * WEBHOOK_BASE_URL unset), fall back to the pre-migration logic: the build-time
 * API base with its trailing /api removed.
 */
export function buildWebhookPreviewUrl(webhookBaseUrl: string | undefined, apiBase: string | undefined, tenantId: string): string {
  const serverBase = (webhookBaseUrl ?? '').trim().replace(/\/+$/, '');
  const base = serverBase || (apiBase || '/api').replace(/\/api\/?$/, '');
  return `${base}/webhook/${tenantId}`;
}

export interface ForwardRelayBadge {
  label: string;
  classes: string;
  title: string;
}

const FORWARD_RELAY_TITLE =
  'Affiche uniquement le drapeau forward_webhooks (relais Scaleway → K8s, modifiable en SQL seulement). ' +
  "Il n'agit que sur les endpoints Stripe qui ciblent encore l'URL Scaleway ; " +
  'sans effet pour ceux qui ciblent déjà K8s directement (connector.klever.be, klever-connector*.creacore.be).';

/** Read-only tenant-list badge for the phase-1 forwarding flag (spec §5). */
export function forwardRelayBadge(forwardWebhooks: boolean | undefined): ForwardRelayBadge {
  return forwardWebhooks === true
    ? { label: 'Relais K8s : actif', classes: 'bg-indigo-100 text-indigo-800', title: FORWARD_RELAY_TITLE }
    : { label: 'Relais K8s : inactif', classes: 'bg-gray-100 text-gray-800', title: FORWARD_RELAY_TITLE };
}
